// extracted by mini-css-extract-plugin
export default {"toolbarReverseColor":"TitleTranslucent_toolbarReverseColor__gY2Ha"};